import { render, staticRenderFns } from "./popFestival.vue?vue&type=template&id=4041cf21&scoped=true&"
import script from "./popFestival.vue?vue&type=script&lang=js&"
export * from "./popFestival.vue?vue&type=script&lang=js&"
import style0 from "./popFestival.vue?vue&type=style&index=0&id=4041cf21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4041cf21",
  null
  
)

export default component.exports